import { InjectionToken } from "@angular/core";

export const GoogleApiKeyToken = new InjectionToken("GoogleApiKeyToken");
